import React from "react";
import style from "../Exst_Edu/Exst_Edu.module.css";
import Sidebar from "../../Sidebar/Sidebar";
import Table from "../Table/Table";

import { Link } from "react-router-dom";

const Exst_Edu = () => {
  return (
    <>
      <div className="flex">
        <Sidebar />
        <div>
          <p className={`${style.header} px-12 pt-8`}> Educators Statistics</p>
          <div className="ml-12 mt-11">
            <Table />
          </div>
          <div className={`${style.btnFinal} mt-8 ml-20`}>
            <button>
              <Link to="/Admin_Dashboard">Dashboard</Link>
            </button>
          </div>
        </div>

        <div>
          <div className={`${style.search}`}></div>
          <div className={`${style.data} flex flex-col gap-10 ml-12`}>
            <div>
              <div className={`${style.block1}`}></div>
              <p className={`${style.blockHeader} ml-20 text-xs -mt-14`}>
                Total Students
              </p>
              <p className={`${style.blockMainHeader} ml-20 text-2xl`}>12345</p>
            </div>
            <div>
              <div className={`${style.block2}`}></div>
              <p className={`${style.blockHeader} ml-20 text-xs -mt-14`}>
                Existing Educators
              </p>
              <p className={`${style.blockMainHeader} ml-20 text-2xl`}>123</p>
            </div>
            <div>
              <div className={`${style.block3}`}></div>
              <p className={`${style.blockHeader} ml-20 text-xs -mt-14`}>
                Unverified Educators
              </p>
              <p className={`${style.blockMainHeader} ml-20 text-2xl`}>12</p>
            </div>
            <div>
              <div className={`${style.block4}`}></div>
              <p className={`${style.blockHeader} ml-20 text-xs -mt-14 `}>
                Negative reviews
              </p>
              <p className={`${style.blockMainHeader} ml-20 text-2xl`}>40</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Exst_Edu;
